export default "__VITE_ASSET__DBsQWksf__"